import _ from 'lodash';
import request from '@/util/request';


const permit1 = {number: 'FN001', title: '账户管理', icon: 'cog', level: 0};
const permit2 = {number: 'FN002', title: '订单管理', icon: 'edit'};
const permit3 = {number: 'FN003', title: '采购管理', icon: 'check-square-o'};
const permit4 = {number: 'FN004', title: '出运管理', icon: 'plane'};

const permit5 = {number: 'FN005', title: '审批管理', icon: 'edit'};
// const permit5 = {number: 'FN005', title: '管理中心', icon: 'users'};  合并到基础资料了
const permit6 = {number: 'FN006', title: '财务管理', icon: 'jpy'};
const permit7 = {number: 'FN007', title: '技术部', icon: 'code'};
const permit8 = {number: 'FN008', title: '基础资料', icon: 'database'};
// const permit9 = {number: 'FN009', title: '报表管理', icon: 'cube'};
const permit9 = {number: 'FN009', title: '模板', icon: 'cube'};

// const permit1_2 = {number: 'FN001_2', pnumber: 'FN001', title: '用户管理', icon: 'user-plus', path: '/accounts/members'};
// const permit1_3 = {
//     number: 'FN001_3',
//     pnumber: 'FN001',
//     title: '我的小组',
//     icon: 'user-circle-o',
//     path: '/accounts/linkAssignManage',
// };
const permit1_5 = {
    number: 'FN001_5',
    pnumber: 'FN001',
    title: '用户管理',
    icon: 'user-circle-o',
    path: '/accounts/groupLinkAssignManage',
};

const permit1_6 = {
  number: 'FN001_6',
  pnumber: 'FN001',
  title: '工厂组',
  icon: 'user-circle-o',
  path: '/memberTeams',
};

// const permit1_4 = {
//   number: 'FN001_4',
//   pnumber: 'FN001',
//   title: '科室管理',
//   icon: 'building-o',
//   path: '/accounts/departManage',
// };

const permit2_1 = {
    number: 'FN002_1',
    pnumber: 'FN002',
    title: '创建订单',
    icon: 'plus-square',
    path: '/orders/orderCreate_handle',
};
const permit2_2 = {
    number: 'FN002_2',
    pnumber: 'FN002',
    title: '订单列表',
    icon: 'file-text',
    path: '/orders/orders_handle',
};
const permit2_4 = {number: 'FN002_4', pnumber: 'FN002', title: '样品管理', icon: 'clipboard', path: '/sampleMaterialList'};
const permit2_5 = {number: 'FN002_5', pnumber: 'FN002', title: '打样管理', icon: 'clipboard', path: '/proofRoundList'};


const permit3_1 = {
    number: 'FN003_1',
    pnumber: 'FN003',
    title: '面料采购',
    icon: 'plus-square',
    path: '/procurement/fabricProcurement',
};
const permit3_2 = {
    number: 'FN003_2',
    pnumber: 'FN003',
    title: '辅料采购',
    icon: 'file-text',
    path: '/procurement/accessoriesProcurement',
};

const permit3_3 = {
    number: 'FN003_3',
    pnumber: 'FN003',
    title: '材料入库(境外)',
    icon: 'file-text',
    path: '/shipmentDeliveryList?transferMode=outside',
};
const permit3_4 = {
    number: 'FN003_4',
    pnumber: 'FN003',
    title: '材料入库(国内)',
    icon: 'file-text',
    path: '/shipmentDeliveryList?transferMode=inside',
};

const permit4_1 = {
    number: 'FN004_1',
    pnumber: 'FN004',
    title: '成衣发货',
    icon: 'female',
    path: '/bookingSpace/clothesDeliveryList',
};

const permit4_2 = {
    number: 'FN004_2',
    pnumber: 'FN004',
    title: '成衣订舱',
    icon: 'female',
    path: '/bookingSpace/records?bookingType=0',
};

const permit4_3 = {
    number: 'FN004_3',
    pnumber: 'FN004',
    title: '材料订舱[废弃]',
    icon: 'crosshairs',
    path: '/bookingSpace/records?bookingType=1',
};
const permit4_4 = {
    number: 'FN004_4',
    pnumber: 'FN004',
    title: '材料报关[废弃]',
    icon: 'clipboard',
    path: '/orders/customsDeclaration'
};

// const permit4_3 = {
//   number: 'FN004_3',
//   pnumber: 'FN004',
//   title: '成衣出运',
//   icon: 'crosshairs',
//   path: '/bookingShipment',
// };


const permit5_1 = {
    number: 'FN005_1',
    pnumber: 'FN005',
    title: '预算审批',
    icon: 'eye',
    path: '/orders/order-budget-review-list',
};
const permit5_2 = {
    number: 'FN005_2',
    pnumber: 'FN005',
    title: '付款审批',
    icon: 'file-text',
    path: '/paymentApproveLinkList',
};
const permit5_3 = {
    number: 'FN005_3',
    pnumber: 'FN005',
    title: '对账审批',
    icon: 'eye',
    path: '/orders/verifyAccountsList',
};
//


const permit6_1 = {number: 'FN006_1', pnumber: 'FN006', title: '进项发票', icon: 'ticket', path: '/vatInvoiceList'};
const permit6_2 = {number: 'FN006_2', pnumber: 'FN006', title: '费用管理', icon: 'list-alt', path: '/incidentalList'};
const permit6_3 = {number: 'FN006_3', pnumber: 'FN006', title: '对账管理', icon: 'list-ol', path: '/reconciliationList'};
const permit6_4 = {number: 'FN006_5', pnumber: 'FN006', title: '付款列表', icon: 'file-text', path: '/paymentList'};
// const permit6_6 = {number: 'FN006_6', pnumber: 'FN006', title: '发票详情', icon: 'file-text', path: '/invoiceList'};
const permit6_5 = {number: 'FN006_6', pnumber: 'FN006', title: '财务付款', icon: 'th-list', path: '/financialPayment'};
const permit6_6 = {number: 'FN006_4', pnumber: 'FN006', title: '收款管理', icon: 'list-ul', path: '/chargeRecordList'};

const permit6_7 = {
    number: 'FN006_7',
    pnumber: 'FN006',
    title: '订单发票',
    icon: 'th-list',
    path: '/Invoices/manageInvoice'
};

const permit7_1 = {number: 'FN007_1', pnumber: 'FN007', title: '打样中心', icon: 'empire', path: '/proofCenter'};
const permit7_2 = {number: 'FN007_2', pnumber: 'FN007', title: '面料核算', icon: 'empire', path: '/accounting'};


// const permit8_1 = {
//   number: 'FN008_1',
//   pnumber: 'FN008',
//   title: '报关信息',
//   icon: 'copy',
//   path: '/templateDeclareProductList',
// };
// const permit8_2 = {number: 'FN008_2', pnumber: 'FN008', title: '报关抬头', icon: 'file-text-o', path: '/tradeDeclareTitle'};
// const permit8_3 = {
//   number: 'FN008_3',
//   pnumber: 'FN008',
//   title: '箱单发票',
//   icon: 'clipboard',
//   path: '/templateBillInvoiceTitle',
// };

const permit8_1 = {number: 'FN008_1', pnumber: 'FN008', title: '客户管理', icon: 'user-o', path: '/clientManage'};
const permit8_2 = {number: 'FN008_2', pnumber: 'FN008', title: '供应商管理', icon: 'user', path: '/vendorList'};
const permit8_3 = {number: 'FN008_3', pnumber: 'FN008', title: '打样间管理', icon: 'building', path: '/proofRoomManage'};

// const permit8_4 = {number: 'FN008_4', pnumber: 'FN008', title: '模板管理', icon: 'building', path: '/basicData/templateManagement'};
const permit8_4 = {
    number: 'FN008_4',
    pnumber: 'FN008',
    title: '业务设置',
    icon: 'address-card-o',
    path: '/basicData/businessSetting'
};


// const permit9_1 = {number: 'FN009_1', pnumber: 'FN009', title: '报表总览', icon: 'user-o', path: '/clientManage'};
// const permit9_2 = {number: 'FN009_2', pnumber: 'FN009', title: '客户统计', icon: 'user', path: '/vendorList'};
// const permit9_3 = {number: 'FN009_3', pnumber: 'FN009', title: '业务员统计', icon: 'building', path: '/proofRoomManage'};
// const permit9_4 = {number: 'FN009_4', pnumber: 'FN009', title: '供应商统计', icon: 'building', path: '/template'};

const permit9_1 = {
    number: 'FN009_1',
    pnumber: 'FN009',
    title: '报关要素',
    icon: 'copy',
    path: '/templateDeclareProductList',
};
const permit9_2 = {number: 'FN009_2', pnumber: 'FN009', title: '报关抬头', icon: 'file-text-o', path: '/tradeDeclareTitle'};
const permit9_3 = {
    number: 'FN009_3',
    pnumber: 'FN009',
    title: '箱单发票',
    icon: 'clipboard',
    path: '/templateBillInvoiceTitle',
};
const permit9_4 = {
    number: 'FN009_4',
    pnumber: 'FN009',
    title: '面辅料模板',
    icon: 'clipboard',
    path: '/fabricAndAccessoryList',
};

const permit10 = {
    number: 'FN010',
    icon: 'clipboard',
    title: '统计报表',
    path: '/census',
}

const permit11={
  number:'FN011',
  icon:'clipboard',
  title:'工厂管理',
}

const permit11_1 = {
  number: 'FN011_1',
  pnumber: 'FN011',
  title: '裁剪',
  icon: 'clipboard',
  path: '/orderCuttingProcess',
};

const permit11_2 = {
  number: 'FN011_2',
  pnumber: 'FN011',
  title: '生产录入',
  icon: 'clipboard',
  path: '/clothesProduceContain',
};

const permit11_3 = {
  number: 'FN011_3',
  pnumber: 'FN011',
  title: 'BST/生产详情',
  icon: 'clipboard',
  path: '/clothesProduceOrderList',
};

const permit11_4 = {
  number: 'FN011_4',
  pnumber: 'FN011',
  title: '小组统计',
  icon: 'clipboard',
  path: '/clothesProduceGroupCensus',
};

const permit11_6 = {
  number: 'FN011_6',
  pnumber: 'FN011',
  title: '成衣包装',
  icon: 'clipboard',
  path: '/orderClothesPackProcess',
};
const permit12 = {
  number: 'FN012',
  title: '库存',
  icon: 'clipboard',
};

const permit12_1 = {
  number: 'FN012_1',
  pnumber: 'FN012',
  title: '库存采购',
  icon: 'clipboard',
  path:'/goodsPurchaseListPage',
};
const permit12_2 = {
  number: 'FN012_1',
  pnumber: 'FN012',
  title: '库存管理',
  icon: 'clipboard',
  path:'/inventoryList',
};
//permit4_3, permit4_4, 订舱的两个放出来
// permit11_6这个进度...
const allList = [

  permit12,permit12_1,permit12_2,
  permit11,permit11_1,permit11_2,permit11_3,permit11_4,permit11_6,
    permit10,
    permit1,
    permit1_5,permit1_6,
    permit2,
    permit2_1, permit2_2, permit2_4, permit2_5,
    permit3,
    permit3_1, permit3_2, permit3_3, permit3_4,
    permit4,
    permit4_1, permit4_2,
    permit5,
    permit5_1, permit5_2, permit5_3,
    permit6,
    permit6_1, permit6_2, permit6_3, permit6_4, permit6_5, permit6_6, permit6_7,
    permit7,
    permit7_1, permit7_2,
    permit8,
    permit8_1, permit8_2, permit8_3, permit8_4,
    permit9,
    permit9_1, permit9_2, permit9_3, permit9_4,
];


async function remoteGetPermit(roleNum) {
    return new Promise(resolve => {
        request.get('/api/role_menu_set', {roleNum: roleNum}).then(res => {
            if (res.data) {
                const numberList = res.data.numberListJson ? JSON.parse(res.data.numberListJson) : [];
                const permitList = (res.operateData && res.operateData.codeListJson) ? JSON.parse(res.operateData.codeListJson) : [];
                const filterList = _.filter(allList, item => numberList.indexOf(item.number) > -1);
                resolve({
                    status: true, list: filterList, permitList: permitList,
                });
            } else {
                resolve({status: true, list: _.clone(allList), permitList: []});
            }

        });

    })

}


function findThenPushMenu(childItem: any, menuList: any[], index: number) {

    if (menuList[index].number == childItem.pnumber) {
        if (!menuList[index].children) {
            menuList[index].children = [];
        }
        menuList[index].children.push(_.pick(childItem, ['number', 'title', 'icon', 'path']));

        return true;
    } else {

        if (menuList[index].children) {
            // 有子项的话就要去子项里探查，子项找到了，那么停止，没找到的话还是要下标+1进行下一轮的
            const exitInChildren = findThenPushMenu(childItem, menuList[index].children, 0);

            if (exitInChildren) {
                return true;
            } else {

                if (index < menuList.length - 1) {
                    index++;
                    return findThenPushMenu(childItem, menuList, index);
                } else {
                    return false;
                }

            }
        } else {

            if (index < menuList.length - 1) {
                index++;
                return findThenPushMenu(childItem, menuList, index);
            } else {
                return false;
            }

        }


    }
}

async function getMenuList(roleNum: number) {

    const emptyMenuList: any = [
        {path: '/index', title: '首页', icon: 'home'},

    ];


    const result: any = await remoteGetPermit(roleNum);
    const permitList = result.list;
    const operatePermitList = result.permitList;
    // console.log("先创立主菜单");
    _.each(_.filter(permitList,o=>o.pnumber==null), (permitItem) => {
      emptyMenuList.push(_.pick(permitItem, ['number', 'path', 'title', 'icon']));
    });

    _.each(permitList, (permitItem) => {
        if (permitItem.pnumber) {
            findThenPushMenu(permitItem, emptyMenuList, 0);
        }
    });

    if (roleNum == 0) {
        emptyMenuList.push({path: '/permit', title: '菜单权限', icon: 'cogs'});
        emptyMenuList.push({path: '/approval-workflows', title: '审批设置', icon: 'sliders'});
    }

    return {menuList: emptyMenuList, permitList: permitList, operatePermitList: operatePermitList};
}


// 这个是实际显示在后台做成页面上的标签的名称
export {getMenuList, allList};
